import React, {useState, useEffect} from 'react'
import {apiExit} from 'api-methods'

const LogoutPage = () => {
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        let isMounted = true

        apiExit()
            .then(data => {if (isMounted) {console.log(data)}})
            .catch(error => {if (isMounted) {console.error('Logout error:', error)}})
            .finally(() => {if (isMounted) {setIsLoading(false)}})

        return () => {isMounted = false}
    }, [])

    if (isLoading) {return <div>Logging out...</div>}

    return <div/>
}

export default LogoutPage